import Vue from "vue";
import Requests from "@/constants/Requests";
import { isEmpty } from "lodash";

const UserService = {
  verifyLastName: (lastname = "", uid = "") => {
    return Vue.prototype.$http.post(Requests.auth.verifyLastname, {
      last_name: lastname,
      uid: uid
    });
  },
  verifyPhone: (phone = "", lastName = "") => {
    let params = {
      phone: phone

    };

    if (!isEmpty(lastName)) {
      params.last_name = lastName;

    }
    // if (!isEmpty(uid)) {
    //   params.uid = uid;

    // }
    return Vue.prototype.$http.post(Requests.auth.verifyCell, params);
  },
  verifyOtp: (args = {}) => {
    return Vue.prototype.$http.post(Requests.auth.verifyOtp, {
      otp: args?.otp,
      phone: args?.phone,
      id: args?.id
    });
  },
  fetchProfile: () => {
    return Vue.prototype.$http.get(Requests.auth.profile);
  },
  resendOtp: phone => {
    return Vue.prototype.$http.post(Requests.auth.resendOtp, {
      phone: phone
    });
  },
  saveProfile: params => {
    return Vue.prototype.$http.post(Requests.auth.profile, params);
  },
  verifyInvitation(uid) {
    return Vue.prototype.$http.get(
      Requests.invitation.verify.replace("{uid}", uid)
    );

  },
  acceptContract(id) {
    return Vue.prototype.$http.post(Requests.auth.acceptContract, {
      accept_contract: true,
      id: id
    });
  },
  deleteReference(id) {
    return Vue.prototype.$http.post(Requests.auth.deleteReference, {
      pkreferenz_id: id
    });
  }

};

export { UserService };
